import React, { useEffect, useState } from 'react';
import { Button, Form, Select } from 'antd';
import { apiClient, apiErrorMessage } from '../../../utils';
import { Role, User } from '../../../models';

export function EditUserRolesPage(props: { onSaved: () => void; action: undefined | 'add' | 'del'; selectedUsers: User[] }) {
  const { Option } = Select;

  const [loading, setLoading] = useState(false);
  const [usersLoading, setUsersLoading] = useState(false);
  const [users, setUsers] = useState<(User & { key: string })[]>();
  const [rolesLoading, setRolesLoading] = useState(false);
  const [roles, setRoles] = useState<(Role & { key: string })[]>();

  useEffect(() => {
    loadUsers();
    loadRoles();
  }, []);

  const loadUsers = () => {
    setUsersLoading(true);
    apiClient
      .get('users')
      .then(response => {
        const responseUsers: User[] = response.data;
        const responseData = responseUsers.map(user => {
          return {
            key: user.id,
            ...user,
          };
        });
        setUsers(responseData);
        setUsersLoading(false);
      })
      .catch((reason: any) => {
        setUsersLoading(false);
        apiErrorMessage(reason);
      });
  };

  const loadRoles = () => {
    setRolesLoading(true);
    apiClient
      .get('roles')
      .then(response => {
        const responseRoles: Role[] = response.data;
        const responseData = responseRoles.map(role => {
          return {
            key: role.id,
            ...role,
          };
        });
        setRoles(responseData);
        setRolesLoading(false);
      })
      .catch((reason: any) => {
        setRolesLoading(false);
        apiErrorMessage(reason);
      });
  };

  const onFinish = (values: any) => {
    setLoading(true);
    if (!props.action) {
      return;
    }

    let action = props.action === 'add' ? apiClient.post('users/roles', values) : apiClient.post('users/roles/delete', values);
    action
      .then(() => {
        props.onSaved();
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Form
      labelCol={{ span: 6 }}
      wrapperCol={{ span: 18 }}
      onFinish={onFinish}
      initialValues={{ userIds: props.selectedUsers?.map(user => user.id) }}
    >
      <Form.Item label="Kullanıcılar" name="userIds" rules={[{ required: true, message: 'Zorunlu alan' }]}>
        <Select mode="multiple" disabled={usersLoading} notFoundContent={null} optionFilterProp="label">
          {users?.map(user => (
            <Option key={user.key} value={user.id} label={(user.fullName || '-') + ' (' + user.email + ')'}>
              {(user.fullName || '-') + ' (' + user.email + ')'}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item label="Roller" name="roleIds">
        <Select mode="multiple" disabled={rolesLoading} notFoundContent={null} optionFilterProp="label">
          {roles?.map(role => (
            <Option key={role.key} value={role.id} label={role.name}>
              {role.name}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item wrapperCol={{ offset: 6, span: 18 }}>
        <Button type="primary" htmlType="submit" loading={loading}>
          {props.action === 'add' ? 'Ekle' : 'Sil'}
        </Button>
      </Form.Item>
    </Form>
  );
}
